import Head from 'components/Head'
import ReceiveNews from 'components/ReceiveNews'
import Banner from './Banner'
import WeBelieve from './WeBelieve'
import WhatIs from './whatIs'


export default function InstitutoRealizar({ data }) {
  return (
    <>
    <div className="container-full">
      <div className="container-geral flex-column">
        <Head data={data.seo}/>
        <Banner data={data.banner} />
        <WhatIs data={data.oque}/>
        <WeBelieve data={data.acreditamos} />
      </div>
    </div>
    <ReceiveNews data={data.secaoRecebaNovidades}/>
    </>
  )
}